import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { answersAPI } from '../services/api';
import { Link } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import NavBar from './NavBar';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const [answers, setAnswers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnswers();
  }, []);

  const fetchAnswers = async () => {
    try {
      const response = await answersAPI.getAll();
      setAnswers(response.data);
    } catch (error) {
      console.error('Failed to fetch answers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu cevabı silmek istediğinizden emin misiniz?')) {
      try {
        await answersAPI.delete(id);
        setAnswers(answers.filter(a => a._id !== id));
      } catch (error) {
        console.error('Failed to delete answer:', error);
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Cevaplarım</h2>
            <Link
              to="/create"
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
            >
              Yeni Cevap Oluştur
            </Link>
          </div>

          {loading ? (
            <div className="text-center py-4">Yükleniyor...</div>
          ) : answers.length === 0 ? (
            <div className="text-center py-8 bg-white rounded-lg shadow">
              <p className="text-gray-500 mb-4">Henüz cevap oluşturmadınız</p>
              <Link
                to="/create"
                className="text-blue-600 hover:text-blue-800"
              >
                İlk cevabınızı oluşturun
              </Link>
            </div>
          ) : (
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {answers.map((answer) => (
                <div key={answer._id} className="bg-white rounded-lg shadow p-4">
                  <div className="mb-3">
                    {answer.questionText && (
                      <p className="text-sm text-gray-600 mb-2">{answer.questionText}</p>
                    )}
                    <p className="font-bold text-lg">Cevap: {answer.answerChoice}</p>
                    <p className="text-sm text-gray-700 mt-1">{answer.explanation.substring(0, 100)}...</p>
                  </div>

                  <div className="flex justify-center mb-3">
                    <QRCodeCanvas
                      value={`${window.location.origin}/answer/${answer.shortId}`}
                      size={128}
                    />
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="text-xs text-gray-500">
                      {answer.viewCount} görüntülenme
                    </span>
                    <div className="space-x-2">
                      <Link
                        to={`/edit/${answer._id}`}
                        className="text-blue-600 hover:text-blue-800 text-sm"
                      >
                        Düzenle
                      </Link>
                      <button
                        onClick={() => handleDelete(answer._id)}
                        className="text-red-600 hover:text-red-800 text-sm"
                      >
                        Sil
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;